/* ABSCENTS — Placeholder animado del buscador (solo escritorio con cursor).
   v113: nunca escribe más texto del que cabe antes de la lupa. Cada frase tiene versiones más cortas;
   se usa la más larga que cabe en el ancho real del campo (se mide con su tipografía). */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var inputs = document.querySelectorAll('input.search__input');
  if (!inputs.length) return;

  var FULL = ['Busca por perfume, marca o nota…', 'Busca perfume, marca o nota…', 'Busca un perfume…', 'Buscar…'];
  var FRASES = [
    ['Busca por perfume…', 'Busca un perfume…', 'Buscar…'],
    ['Busca por marca…', 'Busca una marca…', 'Buscar…'],
    ['Busca por nota: vainilla, oud, cuero…', 'Busca por nota: oud, cuero…', 'Busca por nota…', 'Buscar…'],
    FULL
  ];

  var ctx = document.createElement('canvas').getContext('2d');
  function ancho(el, t) {
    var cs = getComputedStyle(el);
    ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    var ls = parseFloat(cs.letterSpacing) || 0;
    return ctx.measureText(t).width + ls * t.length;
  }
  /* Espacio libre = ancho interior menos los rellenos (el derecho deja el hueco de la lupa) */
  function libre(el) {
    var cs = getComputedStyle(el);
    return el.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0) - 4;
  }
  /* La versión más larga que cabe en todos los buscadores visibles */
  function elegir(variantes) {
    var min = Infinity, ref = null;
    inputs.forEach(function (el) {
      var l = libre(el);
      if (el.offsetParent !== null && l > 0 && l < min) { min = l; ref = el; }
    });
    if (!ref) return variantes[0];
    for (var i = 0; i < variantes.length; i++) {
      if (ancho(ref, variantes[i]) <= min) return variantes[i];
    }
    return variantes[variantes.length - 1];
  }

  inputs.forEach(function (el) {
    el.addEventListener('focus', function () { el.placeholder = elegir(FULL); });
  });

  var pi = 0, ci = 0, del = false, p = '';
  function busy() {
    var b = false;
    inputs.forEach(function (el) { if (document.activeElement === el || el.value) b = true; });
    return b;
  }
  function tick() {
    var wait;
    if (ci === 0 && !del) p = elegir(FRASES[pi]);
    if (!busy()) inputs.forEach(function (el) { el.placeholder = p.slice(0, ci); });
    if (del) {
      ci--;
      if (ci <= 0) { del = false; pi = (pi + 1) % FRASES.length; wait = 450; }
      else wait = 26;
    } else {
      ci++;
      if (ci >= p.length) { del = true; wait = 1900; }
      else wait = 50;
    }
    setTimeout(tick, wait);
  }
  setTimeout(tick, 900);
})();
